import { Reducer } from "redux"
import { AnalysisOptionsState, AnalysisOptionsActionTypes, SampleAnalysisState } from "./analysis-options-types"

export const DEFAULT_SAMPLE_STATE: SampleAnalysisState = {
    selectedPipeline: null
}

const initialState: AnalysisOptionsState = {
    areAnalysisOptionsLoaded: false,
    sampleStates: [DEFAULT_SAMPLE_STATE],
}

export const analysisOptionsReducer: Reducer<AnalysisOptionsState> = (
    state: AnalysisOptionsState = initialState,
    action: any
) => {
    switch (action.type) {
        case AnalysisOptionsActionTypes.SET_ARE_ANALYSIS_OPTIONS_LOADED:
            return Object.assign({}, state, {
                areAnalysisOptionsLoaded: action.payload
            })
        case AnalysisOptionsActionTypes.SET_SAMPLE_STATES:
            return Object.assign({}, state, {
                sampleStates: action.payload
            })

        case AnalysisOptionsActionTypes.SET_SAMPLE_STATE: {
            const { sampleState, index } = action.payload
            // preserve ref to state.sampleStates so that only subform i rerenders.
            const newSampleStates =  state.sampleStates.map( (currentState, i) => {
                return i === index ? sampleState : currentState
            })
            return {
                ...state,
                sampleStates:newSampleStates
            }
            
        }
        case AnalysisOptionsActionTypes.INSERT_SAMPLE_STATE: {
            const { sampleState, index } = action.payload
            const newSampleStates = [
                ...state.sampleStates.slice(0, index), 
                sampleState,                       
                ...state.sampleStates.slice(index),   
              ];
            return {
                ...state,
                sampleStates: newSampleStates
            }
        }
        case AnalysisOptionsActionTypes.DELETE_SAMPLE_STATE: {
            const { index } = action.payload
            return {
                ...state,
                sampleStates: [...state.sampleStates.slice(0, index), ...state.sampleStates.slice(index + 1)]
            }
        }
        case AnalysisOptionsActionTypes.SET_SAMPLE_PIPELINE: {
            const { pipeline, index } = action.payload
            // When pipeline changes, clear entry point selections so they don't reference the old pipeline.
            // preserve ref to state.sampleStates so that only subform i rerenders.
            return {
                ...state,
                sampleStates: state.sampleStates.map( (sampleState, i) => {
                    return i === index ? 
                        {
                            ...sampleState, 
                            selectedPipeline: pipeline, 
                            entryPointSelections: {}
                        } 
                        : sampleState
                })
            }
        }
        case AnalysisOptionsActionTypes.SET_SAMPLE_EPS: {
            const { entryPointSelections, index } = action.payload
            const sampleState = state.sampleStates[index]
            const validEntryIds = new Set((sampleState?.selectedPipeline?.entryPoints ?? []).map(ep => ep.entryId))
            const filtered = validEntryIds.size > 0
                ? Object.fromEntries(Object.entries(entryPointSelections).filter(([id]) => validEntryIds.has(id)))
                : {}
            // preserve ref to state.sampleStates so that only subform i rerenders.
            return {
                ...state,
                sampleStates: state.sampleStates.map( (current, i) => {
                    return i === index ? {...current, entryPointSelections: filtered} : current
                })
            }
        }
        case AnalysisOptionsActionTypes.CLEAR_ALL: {
            return initialState
        }
        default: {
            return state
        } 
    }
}
